export const UNKNOWN_ERROR_MESSAGE = "An unknown error occurred";
